type Props = {
  className?: string
  width?: number
  height?: number
}

export const BoxesIcon = ({ className, width = 42, height = 43 }: Props) => {
  return (
    <span className={className}>
      <svg width={width} height={height} viewBox="0 0 42 43" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask
          id="mask0_7208_1311"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="42"
          height="43"
        >
          <rect y="0.499756" width="41.6667" height="41.6667" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_7208_1311)">
          <mask
            id="mask1_7208_1311"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="21"
            height="22"
          >
            <rect x="0.000976562" y="0.499756" width="20.7922" height="20.7922" fill="#4B99E6" />
          </mask>
          <g mask="url(#mask1_7208_1311)">
            <rect
              width="54.7164"
              height="31.7355"
              transform="matrix(1.19249e-08 -1 -1 -1.19249e-08 29.4868 55.2163)"
              fill="#D9D9D9"
            />
            <g filter="url(#filter0_f_7208_1311)">
              <g clipPath="url(#paint0_angular_7208_1311_clip_path)" data-figma-skip-parse="true">
                <g transform="matrix(0.0348213 -0.0348213 0.0348213 0.0348213 9.25043 16.8846)">
                  <foreignObject x="-922.222" y="-922.222" width="1844.44" height="1844.44">
                    <div
                      style={{
                        background:
                          'conic-gradient(from 90deg,rgba(200, 228, 254, 1) 0deg,rgba(64, 173, 135, 1) 360deg)',
                        height: '100%',
                        width: '100%',
                        opacity: 1,
                      }}
                    />
                  </foreignObject>
                </g>
              </g>
              <circle cx="7.31591" cy="18.8191" r="41.5845" transform="rotate(45 7.31591 18.8191)" />
            </g>
            <g filter="url(#filter1_f_7208_1311)">
              <circle cx="6.50624" cy="10.3488" r="16.4149" fill="url(#paint1_radial_7208_1311)" fillOpacity="0.4" />
            </g>
          </g>
          <mask
            id="mask2_7208_1311"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="20"
            y="21"
            width="21"
            height="22"
          >
            <rect x="20.0415" y="21.292" width="20.7922" height="20.7922" fill="#4B99E6" />
          </mask>
          <g mask="url(#mask2_7208_1311)">
            <rect
              width="41.5845"
              height="24.0752"
              transform="matrix(1.19249e-08 -1 -1 -1.19249e-08 43.7129 61.7825)"
              fill="#D9D9D9"
            />
            <g filter="url(#filter2_f_7208_1311)">
              <g clipPath="url(#paint2_angular_7208_1311_clip_path)" data-figma-skip-parse="true">
                <g transform="matrix(0.0267346 -0.0267346 0.0267346 0.0267346 28.4984 32.654)">
                  <foreignObject x="-928.944" y="-928.944" width="1857.89" height="1857.89">
                    <div
                      style={{
                        background:
                          'conic-gradient(from 90deg,rgba(200, 228, 254, 1) 0deg,rgba(64, 173, 135, 1) 360deg)',
                        height: '100%',
                        width: '100%',
                        opacity: 1,
                      }}
                    />
                  </foreignObject>
                </g>
              </g>
              <circle cx="27.0132" cy="34.1393" r="31.9271" transform="rotate(45 27.0132 34.1393)" />
            </g>
            <g filter="url(#filter3_f_7208_1311)">
              <circle cx="26.7508" cy="27.3106" r="12.5848" fill="url(#paint3_radial_7208_1311)" fillOpacity="0.4" />
            </g>
          </g>
        </g>
        <defs>
          <filter
            id="filter0_f_7208_1311"
            x="-41.2723"
            y="-29.7691"
            width="97.1764"
            height="97.1764"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="3.50185" result="effect1_foregroundBlur_7208_1311" />
          </filter>
          <clipPath id="paint0_angular_7208_1311_clip_path">
            <circle cx="7.31591" cy="18.8191" r="41.5845" transform="rotate(45 7.31591 18.8191)" />
          </clipPath>
          <filter
            id="filter1_f_7208_1311"
            x="-16.9124"
            y="-13.0699"
            width="46.8375"
            height="46.8372"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="3.50185" result="effect1_foregroundBlur_7208_1311" />
          </filter>
          <filter
            id="filter2_f_7208_1311"
            x="-11.9178"
            y="-4.79154"
            width="77.8619"
            height="77.8617"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="3.50185" result="effect1_foregroundBlur_7208_1311" />
          </filter>
          <clipPath id="paint2_angular_7208_1311_clip_path">
            <circle cx="27.0132" cy="34.1393" r="31.9271" transform="rotate(45 27.0132 34.1393)" />
          </clipPath>
          <filter
            id="filter3_f_7208_1311"
            x="7.16231"
            y="7.72213"
            width="39.1768"
            height="39.1771"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="3.50185" result="effect1_foregroundBlur_7208_1311" />
          </filter>
          <radialGradient
            id="paint1_radial_7208_1311"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(20.3293 26.7637) rotate(-110.519) scale(39.4356)"
          >
            <stop offset="1" stopColor="#E2FFF5" />
          </radialGradient>
          <radialGradient
            id="paint3_radial_7208_1311"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(37.3485 39.8954) rotate(-110.519) scale(30.234)"
          >
            <stop offset="1" stopColor="#E2FFF5" />
          </radialGradient>
        </defs>
      </svg>
    </span>
  )
}
